export enum ERP {
  REQUEST = 'ERP_REQUEST',
  SUCCESS = 'ERP_SUCCESS',
  FAILURE = 'ERP_FAILURE'
}

export enum ERP_DETAIL {
  REQUEST = 'ERP_DETAIL_REQUEST',
  SUCCESS = 'ERP_DETAIL_SUCCESS',
  FAILURE = 'ERP_DETAIL_FAILURE'
}
